import { render, staticRenderFns } from "./InputUploadFile.vue?vue&type=template&id=850333b2&scoped=true"
import script from "./InputUploadFile.vue?vue&type=script&lang=js"
export * from "./InputUploadFile.vue?vue&type=script&lang=js"
import style0 from "./InputUploadFile.vue?vue&type=style&index=0&id=850333b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850333b2",
  null
  
)

export default component.exports